module.exports = __webpack_public_path__ + "img/657983f.jpg";